export default "__VITE_ASSET__C5bsfdy$__"